import { RootState } from "@/modules/common";

export const selectSearch = (state: RootState) => state.products.search;
